import { chainConfigs, ChainId } from 'bzx-common/src/config/appConfig'
import { RootStore } from 'bzx-common/src/stores'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { Button, Icon } from 'ui-framework'

const supportedChains: ChainId[] = [1, 56, 137]

interface IButtonChainSwitch {
  chainId?: ChainId
  children?: React.ReactNode
  allChainsSwitches?: boolean
  onlyIcon?: boolean
  className?: string
  rootStore: RootStore
}

/**
 * Note: this is currently based on the website domains.
 * NOT the network the user is connected to, until we have the apps working on any network.
 */
export function ButtonChainSwitch(props: any) {
  const { rootStore, children, allChainsSwitches, chainId, onlyIcon, className } =
    props as IButtonChainSwitch
  const { web3Connection } = rootStore

  if (allChainsSwitches) {
    return (
      <>
        {supportedChains.map((chainId) => {
          const { name, color } = chainConfigs[chainId].icon
          return (
            <Button
              key={chainId}
              variant="neutral"
              onClick={web3Connection.switchNetwork}
              onClickEmit="value"
              value={chainId}>
              <span className="flex-row-center">
                <Icon size={24} name={name} color={color} />
                <span className="margin-left-1ch">
                  {chainConfigs[chainId].chainDetails.chainName}
                </span>
              </span>
            </Button>
          )
        })}
      </>
    )
  }
  if (chainId) {
    const { name, color } = chainConfigs[chainId].icon
    if (onlyIcon) {
      return (
        <Button
          variant="neutral"
          onClick={web3Connection.switchNetwork}
          onClickEmit="value"
          value={chainId}
          className={`flex-row-center btn-chain-switch--only-icon ${className || ''}`}>
          <Icon size={24} name={name} color={color} />
        </Button>
      )
    }
    return (
      <Button
        variant="neutral"
        onClick={web3Connection.switchNetwork}
        onClickEmit="value"
        value={chainId}
        className={`flex-row-center${className || ''}`}>
        <Icon size={24} name={name} color={color} />
        <span className="margin-left-1ch">{children}</span>
      </Button>
    )
  }

  return null
}

export default inject('rootStore')(observer(ButtonChainSwitch))
